import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getUserToken, setUserToken } from '../authSlice';
import { fetchTokenWithCode } from './hwbService'
import { useTranslation } from 'react-i18next';

const HwbLogin = () => {
  const { search, state } = useLocation();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => getUserToken(state));
  const [code, setCode] = useState<string>();
  const { t:_ } = useTranslation();

  const redirect = localStorage.getItem('callback-url') ?? "/"

    useEffect(() => {
    if (state?.from?.pathname) {
      localStorage.setItem('callback-url', state.from.pathname)
    } else {
      if (token) {
        localStorage.removeItem('callback-url');
      } 
    }
  }, [state, token, redirect])

  useEffect(() => {
    if (token) return;
    const endpoint = `${process.env.REACT_APP_RESOURCES_API_URL}hwbauth/login`;
    if (!search) window.location.replace(endpoint);
    setCode(search.split('=')[1]);
  }, [search, token]);

  useEffect(()=>{
    if(!code || token) return;
    fetchTokenWithCode(code).then((userToken) => {
      if (userToken) dispatch (setUserToken(userToken));
    })
  },[code, dispatch, token])

  return token ? <Navigate to={redirect} replace/> : <p>{_("Loading")}....</p>
};

export default HwbLogin;
